var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("坏账审核列表-代采")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "row"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "200px",
                                      "line-height": "40px",
                                      "font-size": "14px",
                                      color: "#606266"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  搜索条件:\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "商品货号" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.goods_no,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "goods_no",
                                                $$v
                                              )
                                            },
                                            expression: "form.goods_no"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "商品名称" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.goods_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "goods_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.goods_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "市场" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.market_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "market_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.market_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "商家" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.supply_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "supply_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.supply_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              multiple: "",
                                              placeholder: "请选择商家城市"
                                            },
                                            model: {
                                              value: _vm.form.city,
                                              callback: function($$v) {
                                                _vm.$set(_vm.form, "city", $$v)
                                              },
                                              expression: "form.city"
                                            }
                                          },
                                          _vm._l(_vm.citys, function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "代采单" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.woid,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "woid", $$v)
                                            },
                                            expression: "form.woid"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "代采组" },
                                            model: {
                                              value: _vm.form.pgid,
                                              callback: function($$v) {
                                                _vm.$set(_vm.form, "pgid", $$v)
                                              },
                                              expression: "form.pgid"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.pgOption,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    value: item.value,
                                                    label: item.label
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "订单负责人"
                                            },
                                            model: {
                                              value: _vm.form.order_owner,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "order_owner",
                                                  $$v
                                                )
                                              },
                                              expression: "form.order_owner"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.owner_option,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    value: item.value,
                                                    label: item.label
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "申请人" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.application_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "application_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.application_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "审核人" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.audit_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "audit_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.audit_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "sku" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.sku,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "sku", $$v)
                                            },
                                            expression: "form.sku"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "欠货来源" },
                                            model: {
                                              value: _vm.form.source,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "source",
                                                  $$v
                                                )
                                              },
                                              expression: "form.source"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.source_option,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    value: item.value,
                                                    label: item.label
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "一级原因" },
                                            on: { change: _vm.setReson },
                                            model: {
                                              value: _vm.form.p_reason_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "p_reason_id",
                                                  $$v
                                                )
                                              },
                                              expression: "form.p_reason_id"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.reasonOption,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.reason_id,
                                                  attrs: {
                                                    label: item.reason_name,
                                                    value: item.reason_id
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "二级原因" },
                                            model: {
                                              value: _vm.form.reason_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "reason_id",
                                                  $$v
                                                )
                                              },
                                              expression: "form.reason_id"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.subReasonOption,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.reason_id,
                                                  attrs: {
                                                    label: item.reason_name,
                                                    value: item.reason_id
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "请选择" },
                                            model: {
                                              value: _vm.form.status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "form.status"
                                            }
                                          },
                                          _vm._l(_vm.statusOption, function(
                                            item
                                          ) {
                                            return _c("el-option", {
                                              key: item.status,
                                              attrs: {
                                                label: item.status_value,
                                                value: item.status
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "次品组"
                                            },
                                            model: {
                                              value: _vm.form.dgid,
                                              callback: function($$v) {
                                                _vm.$set(_vm.form, "dgid", $$v)
                                              },
                                              expression: "form.dgid"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.dg_group,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "退换货负责人"
                                            },
                                            model: {
                                              value: _vm.form.dpc_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "dpc_id",
                                                  $$v
                                                )
                                              },
                                              expression: "form.dpc_id"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.option_dgm,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "代采单类型"
                                            },
                                            model: {
                                              value: _vm.form.cg_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "cg_type",
                                                  $$v
                                                )
                                              },
                                              expression: "form.cg_type"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.cg_type_option,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "售后退供员",
                                              filterable: ""
                                            },
                                            model: {
                                              value: _vm.form.refunder_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "refunder_id",
                                                  $$v
                                                )
                                              },
                                              expression: "form.refunder_id"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.dgm_refunder,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder:
                                                "是否关联盘盈代采单号",
                                              clearable: ""
                                            },
                                            model: {
                                              value: _vm.form.has_other_woid,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "has_other_woid",
                                                  $$v
                                                )
                                              },
                                              expression: "form.has_other_woid"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: { label: "是", value: "1" }
                                            }),
                                            _vm._v(" "),
                                            _c("el-option", {
                                              attrs: { label: "否", value: "0" }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "代采欠货标签"
                                            },
                                            model: {
                                              value: _vm.form.owe_label,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "owe_label",
                                                  $$v
                                                )
                                              },
                                              expression: "form.owe_label"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: "0"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.oweLabelOptions,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "坏账单ID" },
                                          model: {
                                            value: _vm.form.id,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "id", $$v)
                                            },
                                            expression: "form.id"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "扫码出库人" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.form
                                                .stock_out_create_admin_str,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "stock_out_create_admin_str",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.stock_out_create_admin_str"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "代采计划单号"
                                          },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.planid,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "planid", $$v)
                                            },
                                            expression: "form.planid"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "订单生成时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.wo_create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "wo_create_time", $$v)
                                    },
                                    expression: "form.wo_create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "申请时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.application_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "application_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.application_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "审核时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.auditor_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "auditor_time", $$v)
                                    },
                                    expression: "form.auditor_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "退换货生成时间" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.stock_out_create_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "stock_out_create_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.stock_out_create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "warning", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.brokenDebtAudit(0)
                      }
                    }
                  },
                  [_vm._v("通过")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.brokenDebtAudit(1)
                      }
                    }
                  },
                  [_vm._v("\n          驳回")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", size: "small" },
                    on: { click: _vm.output }
                  },
                  [_vm._v("\n          导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark",
                          "cell-class-name": _vm.addColor
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "selection", label: "选择" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "id",
                            label: "坏账单ID",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_img",
                            label: "图片",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: {
                                            src: scope.row.main_img,
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3835964443
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "brand_name",
                            label: "品牌",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_name",
                            label: "商品名称",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "货号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "woid",
                            label: "代采单"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "wcg_order_cg_type_text",
                            label: "代采单类型"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "wo_create_time",
                            label: "代采单生成时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "source",
                            label: "欠货来源"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", [_vm._v(_vm._s(row.source))]),
                                    _vm._v(" "),
                                    row.is_transit_formal
                                      ? _c(
                                          "div",
                                          { staticStyle: { color: "#006cff" } },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(row.is_transit_formal) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            527890616
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "market_name",
                            label: "商家当前市场",
                            width: "55"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_name",
                            label: "商家",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_city",
                            label: "商家当前城市",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "pgname",
                            label: "代采组"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "order_owner_name",
                            label: "订单负责人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dg_group_name",
                            filterable: "",
                            label: "次品组",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dgm_name",
                            filterable: "",
                            label: "退换货负责人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "refunder",
                            filterable: "",
                            label: "售后退供员",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "co_val",
                            label: "颜色",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "si_val",
                            label: "尺码",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sku",
                            label: "sku",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: "代采单价",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "first_reson",
                            label: "一级原因",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "second_reson",
                            label: "二级原因",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "坏账凭证",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      _vm._l(scope.row.docs, function(
                                        item,
                                        key
                                      ) {
                                        return _c("img", {
                                          key: key,
                                          staticStyle: {
                                            "max-width": "100%",
                                            "max-height": "100%"
                                          },
                                          attrs: { src: item }
                                        })
                                      }),
                                      0
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            46516799
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "other_woid",
                            label: "盘盈代采单",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "other_goods_no",
                            label: "替代商品号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "merchant_price",
                            label: "替代商品商家价",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "merchant_activity_price",
                            label: "替代商品商家活动价",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "avg_price",
                            label: "替代商品平均代采价",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: {
                              prop: "surplus_price",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "header" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: { effect: "dark" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _vm._v("\n                  坏账差额"),
                                        _c("i", { staticClass: "el-icon-info" })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  坏账差额=代采单价（转坏账商品的原代采价）-替代商品平均代采价（其他入库商品的历史代采单平均价）\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reason",
                            label: "换货差额原因",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "other_create_time",
                            label: "其他入库时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "remark",
                            label: "备注",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "application_name",
                            label: "申请人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "application_time",
                            label: "申请时间",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "broken_debts_record_status",
                            label: "状态",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "audit_name",
                            label: "审核人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "auditor_remark",
                            label: "审核备注",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "update_time",
                            label: "审核时间",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_out_create_admin_str",
                            label: "扫码出库人",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "90"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_out_create_time",
                            label: "退换货生成时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "150"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, sizes, jumper",
                        total: _vm.resData.count,
                        "page-size": _vm.form.page_size,
                        "page-sizes": [50, 100, 200, 500, 1000]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": function(v) {
                          _vm.form.page_size = v
                          _vm.fetchData()
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20129c1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20129c1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseCgBrokenDebts.vue
// module id = null
// module chunks = 